import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DateInputField from "../../components/forms/DateInputField";
import FormError from "../../components/forms/FormError";

class RescheduleSubscriptionDeliveryForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Please note that it may not be possible to reschedule the current delivery depending on if it has started processing.</p>
          <FormFieldsTable>
            <Field
              label="Delivery Date"
              name="deliveryDate"
              placeholder=""
              showDatePicker={this.props.showDatePicker}
              component={DateInputField}
              serverError={this.props.errors.deliveryDate}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RescheduleSubscriptionDeliveryForm"
})(RescheduleSubscriptionDeliveryForm);

export default ReduxForm;